export default __webpack_public_path__ + "static/media/cancel_close.8b6931e4.svg";